class ProductBlockImageCollapsible {
  constructor(element) {
    this.element = element;
    this.isCollapsed = element.getAttribute('data-collapsed') === 'true';
    this.textElement = element.querySelector('[js-collapsible-image-text]');
    this.contentElement = element.querySelector('[js-collapsible-image-content]');
    
    this.init();
  }

  init() {
    this.bindEvents();
    this.updateUI();
  }

  bindEvents() {
    // 绑定点击事件到summary元素
    if (this.textElement) {
      this.textElement.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggle();
      });

      // 添加键盘支持
      this.textElement.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.toggle();
        }
      });
    }
  }

  toggle() {
    this.isCollapsed = !this.isCollapsed;
    this.element.setAttribute('data-collapsed', this.isCollapsed);
    this.updateUI();
  }

  updateUI() {
    // 更新ARIA属性
    if (this.textElement) {
      this.textElement.setAttribute('aria-expanded', !this.isCollapsed);
    }
    
    if (this.contentElement) {
      this.contentElement.setAttribute('aria-hidden', this.isCollapsed);
    }
  }
}

// 初始化所有可收缩的图片块
document.addEventListener('DOMContentLoaded', () => {
  const collapsibleImages = document.querySelectorAll('[js-collapsible-image]');
  
  collapsibleImages.forEach((element) => {
    new ProductBlockImageCollapsible(element);
  });
});

// 导出类以便在其他地方使用
if (typeof module !== 'undefined' && module.exports) {
  module.exports = ProductBlockImageCollapsible;
}